<template>
  <DrawerOverlay
    data-slot="drawer-overlay"
    v-bind="delegatedProps"
    :class="
      cn(
        'tw:data-[state=open]:animate-in tw:data-[state=closed]:animate-out tw:data-[state=closed]:fade-out-0 tw:data-[state=open]:fade-in-0 tw:fixed tw:inset-0 tw:z-50 tw:bg-[var(--overlay)] tw:backdrop-blur-[2px] tw:duration-500',
        props.class,
      )
    "
  />
</template>

<script setup>
import { reactiveOmit } from '@vueuse/core';
import { cn } from '@/shared/utilities/classes';
import { DrawerOverlay } from 'reka-ui';

const props = defineProps({
  forceMount: { default: undefined, type: Boolean, required: false },
  forceRender: { default: undefined, type: Boolean, required: false },
  asChild: { default: undefined, type: Boolean, required: false },
  as: { default: undefined, type: null, required: false },
  class: {
    default: undefined,
    type: [Boolean, null, String, Object, Array],
    required: false,
    skipCheck: true,
  },
});

const delegatedProps = reactiveOmit(props, 'class');
</script>
